"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Decoration = function Decoration(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    "aria-hidden": true,
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    ref: ref
  }, props), (0, _core.jsx)("path", {
    d: "M3.16 27.294l.177.007 11.628.809c1.717.119 3.01 1.632 2.89 3.378-.122 1.747-1.613 3.066-3.33 2.946l-11.628-.808c-1.717-.12-3.01-1.632-2.89-3.379.122-1.746 1.613-3.065 3.33-2.946zm-2-21.9a3.08 3.08 0 014.39-.409l14.856 12.581a3.208 3.208 0 01.401 4.465 3.08 3.08 0 01-4.39.408L1.562 9.858a3.208 3.208 0 01-.4-4.465zM23.997.173c1.626-.563 3.41.322 3.982 1.976l3.636 10.502c.573 1.654-.28 3.452-1.907 4.015-1.627.563-3.41-.321-3.983-1.975L22.09 4.19c-.573-1.655.281-3.452 1.908-4.016z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Decoration);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Decoration, "Decoration", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/Decoration.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/Decoration.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9DdGEvQ2hlZXJ5Q29udGFpbmVyL0RlY29yYXRpb24udHN4Il0sIm5hbWVzIjpbIkRlY29yYXRpb24iLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsVUFBMEUsR0FBRyxTQUE3RUEsVUFBNkUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSLEVBQWdCO0FBQ2pHLFNBQ0U7QUFBSyx1QkFBTDtBQUFpQixJQUFBLEtBQUssRUFBRSxFQUF4QjtBQUE0QixJQUFBLE1BQU0sRUFBRSxFQUFwQztBQUF3QyxJQUFBLE9BQU8sRUFBQyxXQUFoRDtBQUE0RCxJQUFBLEdBQUcsRUFBRUE7QUFBakUsS0FBMEVELEtBQTFFLEdBQ0U7QUFDRSxJQUFBLENBQUMsRUFBQyxtZUFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQURGO0FBUUQsQ0FURDs7ZUFXZSx1QkFBV0QsVUFBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVhUQSxVIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBEZWNvcmF0aW9uOiBSZWZGb3J3YXJkaW5nQ29tcG9uZW50PFNWR1NWR0VsZW1lbnQsIFNWR1Byb3BzPFNWR1NWR0VsZW1lbnQ+PiA9IChwcm9wcywgcmVmKSA9PiB7XG4gIHJldHVybiAoXG4gICAgPHN2ZyBhcmlhLWhpZGRlbiB3aWR0aD17Mzd9IGhlaWdodD17MzR9IHZpZXdCb3g9XCIwIDAgMzcgMzRcIiByZWY9e3JlZn0gey4uLnByb3BzfT5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMy4xNiAyNy4yOTRsLjE3Ny4wMDcgMTEuNjI4LjgwOWMxLjcxNy4xMTkgMy4wMSAxLjYzMiAyLjg5IDMuMzc4LS4xMjIgMS43NDctMS42MTMgMy4wNjYtMy4zMyAyLjk0NmwtMTEuNjI4LS44MDhjLTEuNzE3LS4xMi0zLjAxLTEuNjMyLTIuODktMy4zNzkuMTIyLTEuNzQ2IDEuNjEzLTMuMDY1IDMuMzMtMi45NDZ6bS0yLTIxLjlhMy4wOCAzLjA4IDAgMDE0LjM5LS40MDlsMTQuODU2IDEyLjU4MWEzLjIwOCAzLjIwOCAwIDAxLjQwMSA0LjQ2NSAzLjA4IDMuMDggMCAwMS00LjM5LjQwOEwxLjU2MiA5Ljg1OGEzLjIwOCAzLjIwOCAwIDAxLS40LTQuNDY1ek0yMy45OTcuMTczYzEuNjI2LS41NjMgMy40MS4zMjIgMy45ODIgMS45NzZsMy42MzYgMTAuNTAyYy41NzMgMS42NTQtLjI4IDMuNDUyLTEuOTA3IDQuMDE1LTEuNjI3LjU2My0zLjQxLS4zMjEtMy45ODMtMS45NzVMMjIuMDkgNC4xOWMtLjU3My0xLjY1NS4yODEtMy40NTIgMS45MDgtNC4wMTZ6XCJcbiAgICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihEZWNvcmF0aW9uKTtcbiJdfQ==